import { render, staticRenderFns } from "./Contract_ServiceSplit_Table.vue?vue&type=template&id=573ef2c8"
import script from "./Contract_ServiceSplit_Table.vue?vue&type=script&lang=js"
export * from "./Contract_ServiceSplit_Table.vue?vue&type=script&lang=js"
import style0 from "./Contract_ServiceSplit_Table.vue?vue&type=style&index=0&id=573ef2c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports